// 嵌入式单点登录：支持在 URL 中携带账号密码实现自动登录
// 支持两种位置（hash 模式路由）：
//   1) hash 之前：http://host/?account=xxx&password=yyy#/dashboard
//   2) hash 之内：http://host/#/dashboard?account=xxx&password=yyy
// 可识别的参数名：账号 account / username / sso_account；密码 password / pwd / sso_password

const ACCOUNT_KEYS = ['account', 'username', 'sso_account']
const PASSWORD_KEYS = ['password', 'pwd', 'sso_password']

function pick(params, keys) {
  for (const k of keys) {
    const v = params.get(k)
    if (v) return { key: k, value: v }
  }
  return null
}

function strip(params, keys) {
  let removed = false
  keys.forEach(k => {
    if (params.has(k)) {
      params.delete(k)
      removed = true
    }
  })
  return removed
}

function splitHash() {
  const raw = window.location.hash || ''
  const idx = raw.indexOf('?')
  if (idx === -1) return { path: raw, query: '' }
  return { path: raw.slice(0, idx), query: raw.slice(idx + 1) }
}

// 从 URL 中提取 SSO 凭据；命中后返回 { username, password }，否则返回 null
export function extractSsoCredentials() {
  let username = ''
  let password = ''

  const searchParams = new URLSearchParams(window.location.search)
  const sa = pick(searchParams, ACCOUNT_KEYS)
  const sp = pick(searchParams, PASSWORD_KEYS)
  if (sa && sp) {
    username = sa.value
    password = sp.value
  }

  if (!username || !password) {
    const { query } = splitHash()
    if (query) {
      const hashParams = new URLSearchParams(query)
      const ha = pick(hashParams, ACCOUNT_KEYS)
      const hp = pick(hashParams, PASSWORD_KEYS)
      if (ha && hp) {
        username = ha.value
        password = hp.value
      }
    }
  }

  if (!username || !password) return null
  return { username, password }
}

// 将 URL 中的 SSO 参数抹除（避免明文密码滞留在地址栏/历史中）
export function cleanSsoUrl() {
  const searchParams = new URLSearchParams(window.location.search)
  const searchDirty = strip(searchParams, ACCOUNT_KEYS) | strip(searchParams, PASSWORD_KEYS)

  const { path, query } = splitHash()
  let hashDirty = false
  let newHash = path
  if (query) {
    const hashParams = new URLSearchParams(query)
    hashDirty = strip(hashParams, ACCOUNT_KEYS) | strip(hashParams, PASSWORD_KEYS)
    const rest = hashParams.toString()
    newHash = rest ? `${path}?${rest}` : path
  }

  if (!searchDirty && !hashDirty) return

  const searchStr = searchParams.toString()
  const url = `${window.location.pathname}${searchStr ? `?${searchStr}` : ''}${newHash}`
  window.history.replaceState(null, document.title, url)
}
